import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const reseñas = [
    {
      nombre: "Departamentos Novus",
      cargo: "Departamentos, Puebla",
      fecha: "Lunes 10 de Marzo, 2025",
      opinion:
        "El diseño quedó precioso, cada detalle se ve súper moderno y elegante. Todo combina perfecto.",
    },
    {
      nombre: "Edificio 47 / Guardias de seguridad SPIE",
      cargo: "Edificio, Puebla",
      fecha: "Martes 11 de Marzo, 2025",
      opinion:
        "Nos encantó cómo se ve la fachada, tiene un estilo muy limpio y profesional. Da una gran primera impresión.",
    },
    {
      nombre: "Departamentos Habitad",
      cargo: "Departamentos, Puebla",
      fecha: "Jueves 13 de Marzo, 2025",
      opinion:
        "La iluminación y los acabados están increíbles. Todo se ve muy bonito y moderno, justo lo que queríamos.",
    },
  ];

  return (
    <div className="w-full py-12 bg-white flex flex-col items-center">
      <motion.h2
        className="text-red-700 text-4xl md:text-5xl font-bold mb-8 text-center"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Opiniones sobre nuestros proyectos
      </motion.h2>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4"
      >
        {reseñas.map((res, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-4 text-center px-6 py-8 border rounded-lg shadow-md"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="text-gray-500 text-sm">{res.fecha}</p>

              <h2 className="text-lg md:text-xl font-semibold text-red-700 leading-relaxed">
                “{res.opinion}”
              </h2>

              <div className="mt-4">
                <p className="text-gray-800 font-medium">{res.nombre}</p>
                <p className="text-gray-500 text-sm">{res.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
